{
  "app": {
    "nom": "Recorregut",
    "carregant": "Loading",
    "tancar": "Close",
    "cancellar": "Cancel",
    "desar": "Save",
    "reintentar": "Try again",
    "saltarAlContingut": "Skip to main content"
  },
  "idioma": {
    "canviar": "Change language"
  },
  "navegacio": {
    "mapa": "Map",
    "classificacio": "Leaderboard",
    "menu": "Main menu"
  },
  "sessio": {
    "iniciada": "Session started. You can begin the trail.",
    "noValida": "This QR code is not valid. Check the link in your email.",
    "sortir": "Sign out",
    "sensesessio": "You have not started a session",
    "sensesessioDetall": "You can browse the map and the points. To answer questions you need to register for an event and scan the QR code you will receive by email."
  },
  "mapa": {
    "precisio": "Approximate accuracy of {{metres}}",
    "descripcio": "Map with the trail points. If you use a screen reader, the list of points below has the same information in an accessible format."
  },
  "geolocalitzacio": {
    "activar": "Enable location",
    "explicacio": "To detect when you reach a point we need access to your location. The app only uses it while open and never stores it.",
    "denegada": "You have denied location access. You can enable it in your browser settings.",
    "noDisponible": "This device cannot provide a location.",
    "error": "Could not get your location.",
    "cercant": "Looking for your location",
    "activa": "Location active",
    "pantallaEncesa": "The screen will stay on while you are on the trail"
  },
  "punt": {
    "distancia": "{{distancia}} away",
    "arribat": "You are here",
    "visitat": "Visited",
    "noVisitat": "Pending",
    "respost": "Answered",
    "sensVideo": "This point has no video yet.",
    "acostarse": "Get within {{radi}} to activate this point.",
    "llistaTitol": "Trail points",
    "cap": "No points published yet.",
    "variosTitol": "You are near several points",
    "variosAjuda": "Tap the one you are standing at."
  },
  "video": {
    "titol": "Point video",
    "reproduir": "Play the video",
    "silenciat": "The video starts muted because browsers do not allow autoplay with sound. Tap the sound icon to turn it on.",
    "bloquejat": "Your browser blocked autoplay. Tap the button to watch the video.",
    "descripcio": "Content description",
    "noCompatible": "Your browser cannot play this video.",
    "subtitols": "Subtitles",
    "activarSo": "Turn on sound"
  },
  "pregunta": {
    "titol": "Question",
    "respondre": "Submit answer",
    "capSeleccionada": "You must choose an option before submitting.",
    "intentUnic": "You only get one attempt. Once submitted, the answer cannot be changed.",
    "correcta": "Correct answer",
    "incorrecta": "Wrong answer",
    "puntsObtinguts_one": "{{punts}} point",
    "puntsObtinguts_other": "{{punts}} points",
    "haviaRespost": "You had already answered this question.",
    "explicacio": "Explanation",
    "calVisitar": "You need to reach the point first for the question to unlock.",
    "foraDeFranja": "The event is not active right now."
  },
  "classificacio": {
    "titol": "Leaderboard",
    "posicio": "Position",
    "equip": "Team",
    "punts": "Points",
    "encerts": "Correct",
    "durada": "Duration",
    "senseDades": "No team has scored yet.",
    "actualitzat": "Updated at {{hora}}",
    "actualitzar": "Refresh",
    "enCurs": "Event in progress",
    "acabat": "Event finished",
    "vosaltres": "Your team"
  },
  "registre": {
    "titol": "Registration",
    "nomEquip": "Team name",
    "responsable": "Person in charge",
    "telefon": "Contact phone",
    "numPersones": "Number of people",
    "menors": "Minors must be accompanied by the adult responsible for the team.",
    "email": "Email address",
    "idiomaPreferit": "Preferred language",
    "consentimentTitol": "Data protection",
    "consentiment": "I have read and I <destacat>accept</destacat> the processing of my personal data in accordance with the <politica>privacy policy</politica>.",
    "consentimentDetall": "We use the name, phone and email only to run the event and send you the QR code. Contact details are deleted after the retention period.",
    "enviar": "Register team",
    "enviant": "Sending",
    "fet": "Registration complete",
    "fetDetall": "We have sent the QR code to {{email}}. You can also start straight from this device.",
    "correuFallat": "We could not send the email, but your registration was saved. You can start from this device or ask the organisers for your code.",
    "comencar": "Start the trail",
    "tancat": "Registration for this event is closed.",
    "obligatori": "This field is required",
    "emailNoValid": "Enter a valid email address",
    "telefonNoValid": "Enter a valid phone number",
    "personesNoValid": "Enter at least one person",
    "consentimentObligatori": "You must accept the data processing to continue",
    "grupEquip": "Team details",
    "grupContacte": "How we reach you",
    "grupContacteAjuda": "This is where you'll get your QR code.",
    "quan": "When",
    "puntsDelRecorregut": "Stops",
    "passos": "How it works",
    "pas1": "Fill in the form and you'll get a QR code by email.",
    "pas2": "On the day, scan the code and the trail begins.",
    "pas3": "At every stop, a video and a question. You get one attempt only."
  },
  "peu": {
    "privacitat": "Privacy policy",
    "credit": "Neighbourhood trail in Hostafrancs"
  },
  "errors": {
    "titol": "Something went wrong",
    "sesion_no_valida": "Your session is not valid. Scan the QR code again.",
    "sesion_requerida": "You need to start a session with your team QR code.",
    "evento_no_encontrado": "We could not find this event.",
    "evento_no_activo": "This event is not active.",
    "evento_fuera_de_franja": "The event has not started yet or is no longer active.",
    "evento_terminado": "The event has already finished.",
    "registro_cerrado": "Registration is already closed.",
    "punto_no_encontrado": "We could not find this point.",
    "punto_no_pertenece_al_evento": "This point is not part of your event.",
    "visita_no_registrada": "You need to reach the point first.",
    "demasiado_lejos": "You are too far from the point. About {{distancia}} metres to go.",
    "pregunta_no_disponible": "This question is not available.",
    "respuesta_ya_enviada": "You had already submitted an answer.",
    "opcion_no_valida": "That option is not valid.",
    "datos_no_validos": "Some of the data is not correct.",
    "credenciales_no_validas": "Those credentials are not correct.",
    "no_autorizado": "You do not have permission to do this.",
    "demasiadas_peticiones": "Too many requests in a row. Please wait a moment.",
    "error_interno": "There was a server error. Please try again.",
    "xarxa": "No connection to the server. Check your signal.",
    "ruta_no_encontrada": "This address does not exist.",
    "rutaTitol": "This page does not exist",
    "rutaDetall": "The address you opened does not match any screen in the app. Check that the link is complete.",
    "enllacTitol": "This access link is not valid",
    "enllacDetall": "The link is incomplete or was copied wrong. Go back to the email with your QR code and open the full link, or scan the code with your camera. If you cannot find it, ask the organisers to send it again.",
    "anarAlRecorregut": "Go to the route",
    "correo_no_enviado": "The email could not be sent. Check the mail settings on the server.",
    "participante_anonimizado": "This team no longer has an email address: the data was deleted."
  },
  "pwa": {
    "actualitzacio": "A new version of the app is available",
    "actualitzar": "Update now",
    "mesTard": "Later"
  },
  "admin": {
    "titol": "Administration",
    "entrar": "Sign in",
    "sortir": "Sign out",
    "email": "Email address",
    "contrasenya": "Password",
    "punts": "Points",
    "esdeveniments": "Events",
    "participants": "Participants",
    "editar": "Edit",
    "desactivar": "Deactivate",
    "actiu": "Active",
    "inactiu": "Inactive",
    "exportar": "Export CSV",
    "veureQr": "View QR code",
    "nom": "Name",
    "descripcio": "Description",
    "latitud": "Latitude",
    "longitud": "Longitude",
    "radi": "Radius in metres",
    "videoUrl": "Video address",
    "videoDescripcio": "Video description",
    "subtitolsUrl": "Subtitles address",
    "inici": "Start",
    "fi": "End",
    "pregunta": "Question",
    "opcions": "Options",
    "respostaCorrecta": "Correct answer",
    "puntsAtorgats": "Points awarded",
    "explicacioBase": "Base explanation",
    "explicacioAmpliada": "Extended explanation",
    "afegirOpcio": "Add option",
    "esborrarOpcio": "Remove option",
    "capPunt": "No points yet.",
    "capEsdeveniment": "No events yet.",
    "traduccioPendent": "Missing {{idioma}} translation",
    "clicarMapa": "Click on the map to place the point",
    "nouPunt": "New point",
    "editarPunt": "Edit point",
    "nouEsdeveniment": "New event",
    "editarEsdeveniment": "Edit event",
    "posicio": "Position",
    "ordre": "Order along the trail",
    "equip": "Team",
    "dataRegistre": "Registration date",
    "obrirDetall": "Show details",
    "tancarDetall": "Hide details",
    "detallEsdeveniment": "Event details",
    "puntsIPreguntes": "Points and questions",
    "enllacInscripcio": "Registration link",
    "afegirPunt": "Add a point to the event",
    "treureDelEsdeveniment": "Remove from event",
    "capPuntAlEsdeveniment": "This event has no points associated yet.",
    "capParticipant": "No team has registered yet.",
    "preguntaDe": "Question for {{punt}}",
    "marcarCorrecta": "Option {{id}} (tick it if it is the correct one)",
    "senseVideo": "No video",
    "videoYoutube": "Video hosted on YouTube: it will start muted and connect to Google.",
    "videoArxiu": "Self-hosted video file: it can start with sound and needs no third party.",
    "qrDe": "QR code for team {{equip}}",
    "ajudaQr": "Show this code to the team if the email did not reach them.",
    "ajudaRadi": "With city GPS, anything under 25 m makes the point hard to trigger.",
    "ajudaVideo": "You can paste a YouTube link or the address of a video file.",
    "ajudaVideoDescripcio": "Alternative text for people who cannot watch the video. Required.",
    "ajudaSubtitols": "Address of the subtitle file in WebVTT format.",
    "ajudaFranja": "Local time. Registration closes automatically at the end time.",
    "ajudaActiu": "If you switch it off, the event is suspended even within its time window.",
    "ajudaExplicacio": "Always shown after answering, whether right or wrong.",
    "ajudaOrdre": "It only sorts the list, it does not force the route.",
    "avisSolapament": "This point overlaps with: {{punts}}. Both could trigger at once.",
    "avisOpcionsIncompletes": "Option texts missing in: {{idiomes}}. Those languages will not be published.",
    "avisDadesPersonals": "This table holds personal data. Do not share it or take screenshots.",
    "falta_nom": "A name is required in at least one language.",
    "falta_posicio": "You must place the point on the map.",
    "falta_franja": "Start and end dates are required.",
    "franjaIncoherent": "The end date must be later than the start date.",
    "falta_enunciat": "The question text is required in at least one language.",
    "falten_opcions": "At least two options are required.",
    "falta_correcta": "You must mark which option is correct.",
    "falten_textos_opcions": "You must fill in the options in at least one complete language.",
    "elMeuCompte": "My account",
    "canviarContrasenya": "Change password",
    "contrasenyaActual": "Current password",
    "contrasenyaNova": "New password",
    "repetirContrasenya": "Repeat the new password",
    "ajudaContrasenya": "At least {{minim}} characters. Use one you do not use anywhere else.",
    "contrasenyaCurta": "The password must be at least {{minim}} characters long.",
    "contrasenyesNoCoincideixen": "The two new passwords do not match.",
    "contrasenyaRepetida": "The new password must be different from the current one.",
    "contrasenyaCanviada": "Password changed. Sessions already open stay active until they expire.",
    "qrCartell": "Poster QR code",
    "ajudaQrCartell": "This code leads to the registration form. It is the same for everyone and holds no personal data, so it can be printed and put up in the street without any concern.",
    "qrCartellAlt": "Registration QR code for {{esdeveniment}}",
    "apuntaA": "Points to:",
    "descarregarQr": "Download for printing",
    "ajudaImpressio": "The image is 2048 pixels: it prints at A4 size without looking jagged.",
    "reenviarAlEquip": "Send to the team",
    "reenviarAMi": "Send me a copy",
    "reenviant": "Sending...",
    "reenviamentFet": "Sent to {{adreca}}",
    "ajudaReenviament": "The team's email goes to the address they registered with. The copy goes to the address of your admin session and is marked as a copy.",
    "reenviamentAnonimitzat": "This team no longer has contact details: they were deleted once the retention period ended. The QR code above is still valid and can be shown on screen.",
    "veureElLloc": "View the public site",
    "qr": "QR",
    "idiomaBase": "base",
    "fontVideoPropi": "Self-hosted",
    "fontVideoYoutube": "YouTube",
    "esborrarOpcioDe": "Remove option {{id}}"
  },
  "diagnostic": {
    "titol": "GPS diagnostics",
    "intro": "A field-testing tool. It measures the real accuracy of the device and the distance to each point. It records no visits and does not affect the trail.",
    "comencar": "Start measuring",
    "reiniciar": "Reset the data",
    "copiar": "Copy the data",
    "copiat": "Data copied",
    "descarregar": "Download CSV",
    "estatActual": "Current state",
    "precisio": "Accuracy",
    "lectures": "Readings",
    "latitud": "Latitude",
    "longitud": "Longitude",
    "estadistiques": "Accuracy during the session",
    "millor": "Best",
    "mediana": "Median",
    "pitjor": "Worst",
    "durada": "Duration",
    "ajudaMediana": "The median is the figure to go by: it copes with isolated spikes better than the mean.",
    "distancies": "Distance to each point",
    "punt": "Point",
    "distancia": "Distance",
    "estat": "State",
    "rebots": "Changes",
    "dins": "Inside the radius",
    "marge": "Within the server margin",
    "fora": "Outside",
    "senseposicio": "No position yet.",
    "canvis": "Entries and exits",
    "ajudaCanvis": "Every entry and exit from the radius. Many changes in a row at the same point mean the radius is too tight for the available signal.",
    "entraA": "enters",
    "surtDe": "leaves",
    "pantallaNoActiva": "The screen may switch off. Tap it now and then.",
    "senseWakeLock": "This browser cannot keep the screen on. Do not lock it."
  },
  "recorregut": {
    "antetitol": "#FemHistòria trail",
    "titol": "Hostafrancs, street by street",
    "intro": "A walk through the neighbourhood's historic spots. At every stop you'll find a video from the #FemHistòria series and a question to answer…",
    "progres_one": "{{fets}} of {{total}} stop",
    "progres_other": "{{fets}} of {{total}} stops",
    "puntsAcumulats_one": "{{punts}} point",
    "puntsAcumulats_other": "{{punts}} points"
  }
}
